var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubOutScanbag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F4F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9236 34.4474C39.0485 29.1823 36.3243 25.2617 33.956 22.9588C33.2668 22.2887 32.9223 21.9537 32.1611 21.6436C31.3999 21.3335 30.7456 21.3335 29.4371 21.3335H26.5629C25.2544 21.3335 24.6001 21.3335 23.839 21.6436C23.0778 21.9537 22.7332 22.2887 22.0441 22.9588C19.6758 25.2617 16.9515 29.1823 16.0764 34.4474C15.4252 38.3647 19.039 41.3335 23.0778 41.3335H32.9223C36.9609 41.3335 40.5748 38.3647 39.9236 34.4474Z",
    stroke: "#2B3674",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6752 17.9237C21.4001 17.5233 21.0014 16.9798 21.825 16.8559C22.6716 16.7285 23.5506 17.308 24.4111 17.2961C25.1895 17.2853 25.5861 16.9401 26.0115 16.4471C26.4595 15.9281 27.1533 14.6665 27.9997 14.6665C28.8461 14.6665 29.5398 15.9281 29.9878 16.4471C30.4133 16.9401 30.8098 17.2853 31.5882 17.2961C32.4487 17.308 33.3278 16.7285 34.1743 16.8559C34.9979 16.9798 34.5993 17.5233 34.3242 17.9237L33.0803 19.734C32.5483 20.5085 32.2823 20.8957 31.7255 21.1144C31.1689 21.3332 30.4494 21.3332 29.0106 21.3332H26.9887C25.5499 21.3332 24.8305 21.3332 24.2738 21.1144C23.717 20.8957 23.451 20.5085 22.9189 19.734L21.6752 17.9237Z",
    stroke: "#2B3674",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8096 30.6567C31.8096 30.6567 28.8636 26.6567 27.8096 26.6567C26.7554 26.6567 23.8096 30.6567 23.8096 30.6567M27.8096 27.3234V35.9901",
    stroke: "#2B3674",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubOutScanbag);
export default __webpack_public_path__ + "static/media/HubOutScanbag.f06406fb8dd7e538eb521da5e12ba051.svg";
export { ForwardRef as ReactComponent };